import { useEffect, useState } from 'react';
import { getPeriod, prepareAndGetChatType } from '../../helpers/StatsHelpers';
import { AccountResponse } from '../../models/account/AccountResponse';
import { ChatType } from '../../types/monitor/ChatType';
import { PeriodType } from '../../types/prompt/PeriodType';

const useMonitorPeriodAndChatType = (
  period: string | undefined,
  chat: string | undefined,
  accountResponse: AccountResponse | null
) => {
  const [monitorPeriod, setMonitorPeriod] = useState<PeriodType | null>(null);
  const [selectedChatType, setSelectedChatType] = useState<ChatType | null>(null);

  useEffect(() => {
    const newMonitorPeriod = getPeriod(period);
    const newSelectedChatType = prepareAndGetChatType(accountResponse, 'ALL', chat);
    setMonitorPeriod(newMonitorPeriod);
    setSelectedChatType(newSelectedChatType);
  }, [period, chat, accountResponse]);

  return { monitorPeriod, selectedChatType };
};

export default useMonitorPeriodAndChatType;
